import angular from 'angular';

/**
 * Сервис аналитики ShbDeployer.
 *
 * Внешняя телеметрия в продукте отключена: никакие данные о действиях пользователей
 * не покидают установку. Сервис сохраняет интерфейс, на который опирается существующий код
 * (eventTrack, setOptOut, setUserRole и т.д.), но все вызовы являются пустыми операциями.
 * Директивы analytics-on/analytics-event в шаблонах остаются инертными атрибутами.
 */
export default angular.module('shbdeployer.analytics', []).factory('$analytics', AnalyticsFactory).name;

function AnalyticsFactory() {
  const noop = () => undefined;

  return {
    eventTrack: noop,
    pageTrack: noop,
    setOptOut: noop,
    setUsername: noop,
    setUserRole: noop,
    clearUserRole: noop,
    setUserEndpointRole: noop,
    clearUserEndpointRole: noop,
    setInstanceStatus: noop,
    setPortainerStatus: noop,
    setCustomVariable: noop,
    deleteCustomVariable: noop,
    trackSiteSearch: noop,
    trackGoal: noop,
    trackLink: noop,
  };
}
